export enum SwrStore {
  LastPrompted = "LastPrompted",
  LastSignInPrompted = "LastSignInPrompted",
  LastPreferencesPrompted = "LastPreferencesPrompted",
  AbTestingMatrix = "AbTestingMatrix",
  LocalBoardType = "LocalBoardType",
  FirestoreBoardType = "FirestoreBoardType",
  LocalPreferences = "LocalPreferences",
  FirestorePreferences = "FirestorePreferences",
  LocalBoard = "LocalBoard",
  FirestoreBoard = "FirestoreBoard",
  LocalFormations = "LocalFormations",
  FirestoreFormations = "FirestoreFormations",
  LocalCustomPlayerTeams = "LocalCustomPlayerTeams",
  FirestoreCustomPlayerTeams = "FirestoreCustomPlayerTeams",
  FirestoreUser = "FirestoreUser",
}

export function getSWRKey<Subkey extends readonly unknown[]>(
  store: SwrStore,
  ...subkey: Subkey
): readonly [SwrStore, ...Subkey] {
  return [store, ...subkey];
}
